import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'crypto-registration-message',
  templateUrl: './registration-message-crypto.component.html',
  styleUrls: [ './registration-message-crypto.component.scss' ],
})
export class RegistrationMessageCryptoComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages-crypto/components-crypto/registration-message-crypto/registration-message-crypto.component.ts